<template>
  <button class="live-button"
          :class="{ live: playing }"
          @click="play()"
  >
    <Loading v-if="loading"/>
    <PlayIcon v-else-if="!playing"/>
    <StopIcon v-else/>
    <span>{{ label }}</span>
    <div class="live-ping"/>
    <div v-if="title" class="live-button__text">
      <BaseTextBillboard :text="title" />
    </div>
    <div v-else class="live-button__skeleton"/>
    <figure class="d-none">
      <audio ref="stream"
             style="width:100%;"
             controls
             preload="none"
      >
        Your browser does not support the
        <code>audio</code> element.
      </audio>
    </figure>
  </button>
</template>
<script>
import Loading from "@/components/ui/Loading.vue";
import StopIcon from "@/components/svg/StopIcon.vue";
import PlayIcon from "@/components/svg/PlayIcon.vue";
import {mapState} from "vuex";
import BaseTextBillboard from "@/components/BaseTextBillboard.vue";

export default {
  name: 'AppStreamPlayer',
  components: {
    BaseTextBillboard,
    PlayIcon,
    StopIcon,
    Loading
  },
  props: {
    title: {
      type: String,
      required: true,
      default: null
    },
    url: {
      type: String,
      required: true
    },
    volume: {
      type: Number,
      required: true,
    },
    mute: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      playing: false,
      loading: false,
      currentEpisodeTitle: null
    }
  },
  computed: {
    ...mapState({
      currentStram() {
        return this.$store.getters['radioPlayer/getCurrentStream'];
      },
      audioProvider() {
        return this.$store.getters['audioPlayer/getProvider'];
      }
    })
  },

  watch: {
    currentStram(stream) {
      if (stream !== this.url) {
        this.pause();
      }
    },
    audioProvider(provider) {
      if (provider !== null) {
        this.pause();
      }
    },
    volume(value) {
      this.$refs.stream.volume = value;
    },
    mute(value) {
      this.$refs.stream.muted = value;
    }
  },
  mounted() {
    this.initListeners(this.$refs.stream);
  },
  methods: {
    initListeners(ref) {
      ref.onplaying = () => {
        this.playing = true;
        this.loading = false;
      }
      ref.onemptied = () => {
        this.loading = false;
        this.playing = false;
      }
      ref.onstalled = () => {
        this.loading = false;
        this.playing = false;
        this.pause();
      }
      ref.onwaiting = () => {
        this.loading = true;
        this.playing = false;
      }
    },
    async playAudio(audioElement, url) {
      try {
        audioElement.setAttribute('src', url);
        await audioElement.play();
      } catch (err) {
        if (err instanceof Error) {
          console.error(err.message);
        }
      }
    },
    play() {
      if (this.$refs.stream.paused) {
        this.playAudio(this.$refs.stream, this.url).then(() => {
          this.$store.commit('audioPlayer/setProvider', null);
          this.$store.commit('radioPlayer/setCurrentStream', this.url);
          this.$store.commit('radioPlayer/setPlaying', true);
        });
      } else {
        this.pause();
      }
    },
    pause() {
      this.$refs.stream.load();
      this.$refs.stream.removeAttribute('src');
      this.$store.commit('radioPlayer/setPlaying', false);
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_live-radio.scss';
</style>